module.exports = __webpack_public_path__ + "static/media/logo-white.45b68501.png";